/**
 * Extract plain text from ProseMirror document
 * @param {Object} doc - ProseMirror document node
 * @returns {string} Plain text content
 */
export function extractPlainText(editorView) {
    // ProseMirror has a built-in textContent property that concatenates all text nodes
    return editorView.state?.doc.textContent || '';
}

/**
 * Extract markdown from ProseMirror document or JSON
 * @param {Object} editorView - ProseMirror editor view or content
 * @returns {string} Markdown content
 */
export function extractMarkdown(editorView) {
    if (!editorView) return '';

    let doc;

    // If it has a TipTap editor reference
    if (editorView.editor) {
        // TipTap has a built-in getText() method that extracts formatted text
        // For now, we'll use textContent as it's more reliable
        doc = editorView.editor.state.doc;
    }
    // Otherwise work directly with the ProseMirror view
    else if (editorView.state?.doc) {
        doc = editorView.state.doc;
    } else {
        return '';
    }

    // For now, return plain text since defaultMarkdownSerializer doesn't support custom marks
    // TODO: Implement custom MarkdownSerializer that handles author, reportFragment, and other custom marks
    return extractPlainText(doc);
}

/**
 * Extract both plain text and markdown from editor
 * @param {Object} editorView - ProseMirror editor view
 * @returns {Object} {plainText, markdown, json}
 */
export function extractAllFormats(editorView) {
    if (!editorView) {
        return {
            plainText: '',
            markdown: '',
            json: null
        };
    }

    let doc;
    let json;

    // If it has a TipTap editor reference
    if (editorView.editor) {
        json = editorView.editor.getJSON();
        doc = editorView.editor.state.doc;
    }
    // Otherwise work directly with the ProseMirror view
    else if (editorView.state?.doc) {
        json = editorView.state.doc.toJSON();
        doc = editorView.state.doc;
    } else {
        return {
            plainText: '',
            markdown: '',
            json: null
        };
    }

    const plainText = extractPlainText(doc);
    const markdown = extractMarkdown(editorView);

    return {
        plainText,
        markdown,
        json
    };
}
